import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';

import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-datlichthuhocphiedit',
  templateUrl: './datlichthuhocphiedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./datlichthuhocphiedit.component.scss'],
  providers: [ListService, Repository]
})


export class datlichthuhocphieditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, DangKyGoiHocId: null, Ngay: null, SoTien: null
    , NoiDung: null, TrangThai: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];
  inputtrangthais: any = [
    { Ten: 'Đặt lịch', Id: 0 },
    { Ten: 'Đã thu', Id: 1 }
  ];
  inputhinhthucs: any = [
    { Ten: 'Thanh toán hết', Id: 0 },
    { Ten: 'Đặt cọc', Id: 1 },
    { Ten: 'Thanh toán 1 phần', Id: 2 }
  ];
  inputphuongthucs: any = [
    { Ten: 'Tiền mặt', Id: 0 },
    { Ten: 'Chuyển khoản', Id: 1 },
    { Ten: 'Quẹt thẻ', Id: 2 },
    { Ten: 'Trả góp', Id: 3 },
    { Ten: 'Không có', Id: 4 },
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('mdChonDoiTuongChung') mdChonDoiTuongChung: BsModalComponent;
  @ViewChild('dtechondoituongchungedit') dtechondoituongchungedit: any;

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  constructor(private _dataService: ListService, public repo: Repository) {


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {

  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any, lopid: string) {


    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";

    this.hoatdong = "Hoạt động"

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }



    }

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);


    this.doituongSelect = {
      Id: null, DangKyGoiHocId: null, Ngay: null, SoTien: null
      , NoiDung: null, TrangThai: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

    };
    if (id === null) {


      this.doituongSelect.Ngay = new Date();
      this.doituongSelect.DangKyGoiHocId = lopid;
      this.doituongSelect.TrangThai = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;


    }
    else {
      console.log("t11");
      this.repo.postRequest("api/dangkygoihoc/getbyid_datlich/", { IdGuid: id, NhomDoiTuongId: nhomdoituongid, UserName: this.currentUser.user_name })
        .subscribe(response => {
          console.log(response);
          this.doituongSelect.Id = id;
          this.doituongSelect.DangKyGoiHocId = lopid;
          this.doituongSelect.SoTien = response.SoTien;
          this.doituongSelect.NoiDung = response.NoiDung;
          this.doituongSelect.TrangThai = response.TrangThai;
          this.doituongSelect.GhiChu = response.GhiChu;
          if (response.Created != null)
          this.doituongSelect.Created = new Date(response.Created);
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();

          if (response.Ngay != null)
            this.doituongSelect.Ngay = new Date(response.Ngay);
          else
            this.doituongSelect.Ngay = null;



        });
    }


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Ngay == null) {
      swal('Lỗi!', 'Vui lòng nhập ngày đặt lịch thu!.', 'error');
      return;
    }
    if (this.doituongSelect.SoTien == null) {
      swal('Lỗi!', 'Vui lòng nhập số tiền!.', 'error');
      return;
    }
   

    //console.log("save_ttt");
    //console.log(this.doituongSelect);
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/addorupdate_datlich", this.doituongSelect)
      .subscribe(response => {
        $('#loading').hide();
        if (response != null && response.match('-')) {
          this.doituongSelect.Id = response;
          this.save.emit(this.doituongSelect);
        }
        else {
          swal('Lỗi!', response, 'error');
        }
      });
  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


  


}
